import { axios } from '@/utils/request'

/**
 * 查询医生查询
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorPage (parameter) {
  return axios({
    url: '/userBasic/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 备案
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function upDataList (parameter) {
  return axios({
    url: '/userBasic/upLoadJg',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除医生
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function useingBaDoctor (parameter) {
  return axios({
    url: '/userBasic/setDoctorStatus',
    method: 'get',
    params: parameter
  })
}


/**
 * 医生查询列表
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorList (parameter) {
  return axios({
    url: '/baDoctor/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加医生查询
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorAdd (parameter) {
  return axios({
    url: '/baDoctor/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑医生查询
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorEdit (parameter) {
  return axios({
    url: '/userBasic/updateDrBaseInfo',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除医生查询
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorDelete (parameter) {
  return axios({
    url: '/baDoctor/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出医生查询
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorExport (parameter) {
  return axios({
    url: '/baDoctor/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}


/**
 * 查询医生信息
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorQuery (parameter) {
  return axios({
    url: '/userBasic/getDoctorBaseInfo',
    method: 'get',
    params: parameter,
  })
}



/**
 * 查询所有科室信息
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorQueryDept (parameter) {
  return axios({
    url: '/userBasic/getDepts',
    method: 'get',
    params: parameter,
  })
}


/**
 * 查询所有科室信息
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorQueryArea (parameter) {
  return axios({
    url: '/userBasic/getArea',
    method: 'get',
    params: parameter,
  })
}




/**
 * 名医设置
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorDoct (parameter) {
  return axios({
    url: '/userBasic/setIsRecom',
    method: 'get',
    params: parameter,
  })
}



/**
 * 权重设置
 *
 * @author liwei
 * @date 2022-04-16 15:41:19
 */
export function baDoctorWeight (parameter) {
  return axios({
    url: '/userBasic/setSortWeight',
    method: 'get',
    params: parameter,
  })
}


/**
 * 修改就诊状态
 * userId 
 * workFlag
 * 
 */
export function baDoctorWord(parameter) {
  return axios({
    url: '/userBasic/setWorkFlag',
    method: 'get',
    params: parameter,
  })
}


/**
 * 问诊开通
 * 
 */
export function baDoctorInterrogation(parameter) {
  return axios({
    url: '/userBasic/openService',  
    method: 'post',
    data: parameter,
  })
}

/**
 * 坐诊信息设置
 */
export function baDoctorInterrogationInfo(parameter) {
  return axios({
    url: '/userBasic/editService',  
    method: 'post',
    data: parameter,
  })
}



/**
 * 获取医生已开通问诊服务
 */
export function baDoctorGetService(parameter) {
  return axios({
    url: '/userBasic/getOpenService',  
    method: 'get',
    params: parameter,
  })
}

/**
 * 修改医生资质信息 
 */
export function doctorEditQuality(parameter) {
  return axios({
    url: '/userBasic/edit',  
    method: 'post',
    data: parameter,
  })
}

/**
 * 获取医生资质信息
 */
export function getDoctordetail(parameter) {
  return axios({
    url: '/userBasic/detail',  
    method: 'get',
    params: parameter,
  })
}

/**
 * 字典 父级id 8：医师执业类别 9：医师执业范围
 */
export function getbaDatadictDetailList(parameter) {
  return axios({
    url: '/baDatadictDetail/list',  
    method: 'get',
    params: parameter,
  })
}
